module.exports = __webpack_public_path__ + "static/media/6.f5fdd011.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格未选中态/6.png
// module id = 1270
// module chunks = 0